// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import de from 'vuetify/lib/locale/de'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader



const opts = {
    theme: {
        themes: {
            light: {
                primary: '#3f51b5',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
            },
        },
    },
    lang: {
        locales: { de },
        current: 'de',
    },
    icons: {
        defaultSet: 'mdi', // This is already the default value - only for display purposes
    },
}

Vue.use(Vuetify)

export default new Vuetify(opts)
